import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../Redux/actions/userActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { useNavigate, Link } from "react-router-dom";
import { showToast } from "../../components/ToastMessage.jsx";
import { useSanitizedInput } from "../../hooks/useSanitizedInput.js";
import "./AuthScreens.css";

const LoginScreen = () => {
  // ✅ Correct destructuring: [value, handleChange, reset, setValueDirect]
  const [emailOrMr, handleEmailOrMrChange] = useSanitizedInput("", "text");
  const [password, handlePasswordChange] = useSanitizedInput("", "text");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo) {
      const role = userInfo.user.role;
      if (role === "admin") navigate("/admin/dashboard");
      else if (role === "doctor") navigate("/doctor/dashboard");
      else if (role === "pharmacist") navigate("/counter");
      else if (role === "receptionist") navigate("/receptionist/walk-in");
      else navigate("/");
      showToast("Login successful!");
    }
  }, [userInfo, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    
    // ✅ Additional validation
    if (!emailOrMr.trim() || !password.trim()) {
      showToast("Please fill all fields", "error");
      return;
    }
    
    if (password.length < 2) {
      showToast("Password must be at least 6 characters", "error");
      return;
    }
    
    dispatch(login(emailOrMr, password));
  };

  return (
    <div className="auth-bg d-flex align-items-center justify-content-center">
      <div className="auth-card shadow-lg p-4 rounded-4">
        <h2 className="text-center mb-4 fw-bold text-teal">Welcome Back 👋</h2>

        {error && <Error message={error} />}
        {loading && <Loading />}

        <form onSubmit={submitHandler}>
          <div className="mb-3">
            <label className="fw-semibold">Email or MR Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter email or MR-00001"
              value={emailOrMr}
              onChange={handleEmailOrMrChange}
              maxLength="100"
              required
              disabled={loading}
            />
          </div>

          <div className="mb-3">
            <label className="fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={handlePasswordChange}
              maxLength="128"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-teal w-100 mb-3" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="text-center">
            <Link to="/forgot-password" className="link-teal">Forgot password?</Link>
          </p>

          <p className="text-center">
            Don't have an account?{" "}
            <Link to="/register" className="link-teal">Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;